
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 16, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

export default {
	title: "Activity",
	description: "glucose.manual_entry",
	type: "object",
	properties: {
		value: {
			type: "number",
			description: "activity.steps",
			placeholder: "activity.steps"
		},
		comment: {
			inputType: "hidden",
			description: "bloodoxygen.commenttitle",
			type: "string",
			multiline: true,
			placeholder: "bloodoxygen.comment"
		}
	}
};
